var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLevel9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d64205;}.b,.c{fill:none;stroke:#003c71;stroke-linecap:round;stroke-width:3px;}.b{stroke-miterlimit:10;}.c{stroke-linejoin:round;}.d{fill:#003c71;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1290 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(1290 524)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(729.894 529.122)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.989,55.361c-3.381-6.57-8.347-11.46-18.644-11.46s-16.13,5.73-18.645,11.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M584.259,30.141,597.244,28.9l-11.989-4.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M619.758,30.114l-12.99-1.185,12.91-4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M620.4,38.072c.243,1.775-.474,2.736-1.6,2.89s-2.237-.558-2.479-2.333,1.54-4.219,1.54-4.219S620.16,36.3,620.4,38.072Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel9);
export default __webpack_public_path__ + "static/media/level9.dcffc6d5fc90b36b6b7eac550380079f.svg";
export { ForwardRef as ReactComponent };